import { render, staticRenderFns } from "./shareReadingList.vue?vue&type=template&id=579d5e2b&scoped=true"
import script from "./shareReadingList.vue?vue&type=script&lang=js"
export * from "./shareReadingList.vue?vue&type=script&lang=js"
import style0 from "./shareReadingList.vue?vue&type=style&index=0&id=579d5e2b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579d5e2b",
  null
  
)

export default component.exports